
import { allCities } from '../../../mocks/serviceAreas';

export default function CityDirectory() {
  return (
    <section className="py-20 bg-brand-cream">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block text-brand-red font-semibold text-sm uppercase tracking-widest mb-3">
            Complete Directory
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-brand-navy mb-4">
            All Covered Cities
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Browse our full list of service locations across Florida. Can&apos;t find your city? Let us know and we&apos;ll check if we can serve your area.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 lg:p-10">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
            {allCities.map((group, i) => (
              <div key={i}>
                <h4 className="text-lg font-bold text-brand-navy border-b-2 border-brand-red pb-2 mb-4">
                  <a href={`#cities-${group.letter}`} className="hover:text-brand-red transition-colors">
                    {group.letter}
                  </a>
                </h4>
                <ul className="space-y-2.5">
                  {group.cities.map((city, j) => (
                    <li
                      key={j}
                      className="text-sm text-gray-700 hover:text-brand-red hover:translate-x-1 transition-all duration-200 cursor-default flex items-center gap-2"
                    >
                      <i className="ri-checkbox-circle-fill text-green-500 text-xs w-3 h-3 flex items-center justify-center"></i>
                      {city}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
